import { render, staticRenderFns } from "./page-container.vue?vue&type=template&id=c4d4cdbe&scoped=true"
import script from "./page-container.vue?vue&type=script&lang=js"
export * from "./page-container.vue?vue&type=script&lang=js"
import style0 from "./page-container.vue?vue&type=style&index=0&id=c4d4cdbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d4cdbe",
  null
  
)

export default component.exports